export const PlanManagementPanel = {
  SUBSCRIPTION: 'subscription',
  LATEST_CHARGES: 'latest-charges',
  PAYMENT_METHOD: 'payment-method',
  CANCEL_SUBSCRIPTION: 'cancel-subscription'
} as const

export type PlanManagementPanel = (typeof PlanManagementPanel)[keyof typeof PlanManagementPanel]
